import { render, staticRenderFns } from "./SiteName.vue?vue&type=template&id=89102436&scoped=true&"
import script from "./SiteName.vue?vue&type=script&lang=js&"
export * from "./SiteName.vue?vue&type=script&lang=js&"
import style0 from "./SiteName.vue?vue&type=style&index=0&id=89102436&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89102436",
  null
  
)

export default component.exports